import { render } from "./MainError.vue?vue&type=template&id=c0e613c6"
import script from "./MainError.vue?vue&type=script&lang=js"
export * from "./MainError.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Active\\Workspace\\www\\ETDotCom_v2\\EndlessTheoryDotCom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__